import { render } from "./NAttachmentsListItemRemovingPopover.vue?vue&type=template&id=23b27838&ts=true"
import script from "./NAttachmentsListItemRemovingPopover.vue?vue&type=script&lang=ts"
export * from "./NAttachmentsListItemRemovingPopover.vue?vue&type=script&lang=ts"

import "./NAttachmentsListItemRemovingPopover.vue?vue&type=style&index=0&id=23b27838&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__